import React, { useState } from 'react';
// import {
//     ACTION_EVENT_CREATE_ATTEMPT,
//     PROPERTY_SOURCE_AUTOCREATE,
//     PROPERTY_SOURCE_MANUAL,
// } from '@eventbrite/event-create-analytics';
// import { HAS_WINDOW } from '@eventbrite/legacy-infra.feature-detection';
// import { logEvent } from '@eventbrite/legacy-infra.statsig';
import { setWindowLocation } from '@eventbrite/legacy-infra.http';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import { MagicWandIcon, PencilIcon } from '@eventbrite/marmalade';
import {
    AUTO_CREATE_EVENT_HREF,
    CREATE_EVENT_HREF,
    CREATE_NEW_EVENT,
    CREATE_NEW_EVENT_SUBTITLE,
    CREATE_NEW_EVENT_WITH_AI,
    CREATE_NEW_EVENT_WITH_AI_SUBTITLE,
    // STATSIG_EVENT_AUTO_CREATE_NEXT_EVENT,
} from './constants';
import styles from './CreateEventAlternatives.module.scss';
import classNames from 'classnames';

// const track = (data: { eventName: string; eventData: Record<string, any> }) => {
//     HAS_WINDOW &&
//         (window as any)?.dataLayer.push({
//             event: 'track',
//             sendToHeap: true,
//             ...data,
//         });
// };

export const CreateEventAlternatives = () => {
    const [isAutoCreateLoading, setIsAutoCreateLoading] = useState(false);
    const [isCreateLoading, setIsCreateLoading] = useState(false);

    return (
        <div
            className={styles.createEventAlternativesContainer}
            role="complementary"
            arial-label="create-event-alternatives"
        >
            <AlternativeContainer
                aria-labelledby="create-title"
                data-testid="next-event-create"
                onClick={() => {
                    !isAutoCreateLoading && setIsCreateLoading(true);
                    // New event tracking
                    // track({
                    //     eventName: ACTION_EVENT_CREATE_ATTEMPT,
                    //     eventData: {
                    //         eventCreateSource: PROPERTY_SOURCE_MANUAL,
                    //         pageArea: 'StartFromScratchInAttendeeHeader',
                    //         hasPublish: (HAS_WINDOW && window.__SERVER_DATA__?.hasPublish) || false,
                    //         hasPaidPublish:
                    //             (HAS_WINDOW && window.__SERVER_DATA__?.hasPaidPublish) || false,
                    //     },
                    // });
                    setWindowLocation(CREATE_EVENT_HREF);
                }}
                isLoading={isCreateLoading}
            >
                {isCreateLoading ? (
                    <div className={styles.loadingWrapper}>
                        <Progress />
                    </div>
                ) : (
                    <React.Fragment key="create-event">
                        <div className={styles.alternativeIconContainer}>
                            <PencilIcon
                                size="medium"
                                aria-hidden="true"
                                color="#3659E3"
                            ></PencilIcon>
                        </div>
                        <h3
                            id="create-title"
                            className={styles.alternativeHeader}
                            aria-label="create-title"
                        >
                            {CREATE_NEW_EVENT}
                        </h3>
                        <p className={styles.alternativeDescription} aria-label="create-subtitle">
                            {CREATE_NEW_EVENT_SUBTITLE}
                        </p>
                    </React.Fragment>
                )}
            </AlternativeContainer>
            <AlternativeContainer
                aria-labelledby="auto-create-title"
                data-testid="next-event-auto-create"
                onClick={() => {
                    !isCreateLoading && setIsAutoCreateLoading(true);
                    // logEvent(STATSIG_EVENT_AUTO_CREATE_NEXT_EVENT);
                    // New event tracking
                    // track({
                    //     eventName: ACTION_EVENT_CREATE_ATTEMPT,
                    //     eventData: {
                    //         eventCreateSource: PROPERTY_SOURCE_AUTOCREATE,
                    //         pageArea: 'CreateMyEventFasterWithAiInAttendeeHeader',
                    //         hasPublish: (HAS_WINDOW && window.__SERVER_DATA__?.hasPublish) || false,
                    //         hasPaidPublish:
                    //             (HAS_WINDOW && window.__SERVER_DATA__?.hasPaidPublish) || false,
                    //     },
                    // });

                    setWindowLocation(AUTO_CREATE_EVENT_HREF);
                }}
                isLoading={isAutoCreateLoading}
            >
                {isAutoCreateLoading ? (
                    <div className={styles.loadingWrapper}>
                        <Progress />
                    </div>
                ) : (
                    <React.Fragment key="auto-create-event">
                        <div className={styles.alternativeIconContainer}>
                            <MagicWandIcon size="medium" aria-hidden="true" color="#3659E3" />
                        </div>
                        <h3
                            id="auto-create-title"
                            className={styles.alternativeHeader}
                            aria-label="auto-create-title"
                        >
                            {CREATE_NEW_EVENT_WITH_AI}
                        </h3>
                        <p
                            className={styles.alternativeDescription}
                            aria-label="auto-create-subtitle"
                        >
                            {CREATE_NEW_EVENT_WITH_AI_SUBTITLE}
                        </p>
                    </React.Fragment>
                )}
            </AlternativeContainer>
        </div>
    );
};

const Progress = () => (
    <svg
        className={styles.progressAnimation}
        viewBox="0 0 100 100"
        role="progressbar"
        aria-valuetext={gettext('In progress').toString()}
    >
        <defs>
            <linearGradient id="stroke-large-thin-gradient-indeterminate">
                <stop offset="0%"></stop>
                <stop offset="50%"></stop>
                <stop offset="100%" stopOpacity="0"></stop>
            </linearGradient>
        </defs>
        <path
            d="M93.5,50C93.5,74,74,93.5,50,93.5S6.5,74,6.5,50S26,6.5,50,6.5"
            stroke="url(#stroke-large-thin-gradient-indeterminate)"
        ></path>
    </svg>
);

interface IAlternativeContainer extends React.ComponentPropsWithoutRef<'div'> {
    isLoading: boolean;
}

const AlternativeContainer = ({ children, isLoading, ...props }: IAlternativeContainer) => (
    <div
        className={classNames(styles.alternativeContainer, {
            [styles.isLoading as string]: isLoading,
        })}
        {...props}
    >
        {children}
    </div>
);
